import axios from "axios";

// Resolve the backend base URL.
//
// In production browsers (any deployed origin, including custom domains like
// majestyio.com), use the page's own origin so API calls are same-origin —
// this avoids CORS issues and keeps auth cookies on the same domain.
//
// In local development (localhost), fall back to REACT_APP_BACKEND_URL so the
// React dev server can talk to the backend running on a different port.
function resolveBackendUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host !== "localhost" && host !== "127.0.0.1" && host !== "0.0.0.0") {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
